import { Building2, User } from "lucide-react";

import type { Contact, ContactKind } from "@/api/development_suite";

export const CONTACT_KIND_LABEL: Record<ContactKind, string> = { person: "Person", organization: "Organization" };

export function ContactKindIcon({ kind, className }: { kind: ContactKind; className?: string }) {
  const Icon = kind === "organization" ? Building2 : User;
  return <Icon className={className} aria-hidden />;
}

/** Roles come from the server as lowercase words; shown capitalized. */
export function roleLabel(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1);
}

/** "Person · pat@example.gov · 555-0100", so a row tells people and firms apart. */
export function contactSummary(contact: Contact): string {
  return [CONTACT_KIND_LABEL[contact.kind], contact.email, contact.phone].filter(Boolean).join(" · ");
}
